import { render, staticRenderFns } from "./actFemaleRules.vue?vue&type=template&id=0e10c584&scoped=true"
import script from "./actFemaleRules.vue?vue&type=script&lang=js"
export * from "./actFemaleRules.vue?vue&type=script&lang=js"
import style0 from "./actFemaleRules.vue?vue&type=style&index=0&id=0e10c584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e10c584",
  null
  
)

export default component.exports